export default {
      id: "cog-outline-usage",
      viewBox: "0 0 24 24",
      url: "/dist/svg/" + "sprite.svg#cog-outline-usage",
      toString: function () {
        return this.url;
      }
    }